<template>
    <v-container>
        <v-row align="center" class="mb-6 mx-0">
            <v-text-field
                v-model="search"
                autofocus
                label="Cari"
                hide-details
                single-line
                append-icon="mdi-magnify"
                class="pt-0"
            ></v-text-field>

            <v-spacer></v-spacer>

            <create-question></create-question>
        </v-row>

        <v-skeleton-loader v-if="! questions" type="table" class="mt-4"></v-skeleton-loader>

        <v-card v-else>
            <v-data-table
                :headers="headers"
                :items="questions"
                item-key="id"
                show-expand
                single-expand
                :expanded.sync="expandedItem"
                :search="search"
                class="mt-4 elevation-0"
            >
                <template #expanded-item="{ headers }">
                    <expanded-question :headers="headers" :item="expandedItem"></expanded-question>
                </template>

                <template #item.action="{ item }">
                    <v-btn @click="edit(item)" small icon>
                        <v-icon>mdi-pencil</v-icon>
                    </v-btn>
                    <v-btn small icon color="error">
                        <v-icon>mdi-delete</v-icon>
                    </v-btn>
                </template>
            </v-data-table>
        </v-card>

        <edit-question-dialog v-model="editDialog"></edit-question-dialog>
    </v-container>
</template>

<script>
import { get } from 'vuex-pathify'
import CreateQuestion from '@/components/dashboard/questionbank/CreateQuestion'
import ExpandedQuestion from '@/components/dashboard/questionbank/ExpandedQuestion'
import EditQuestionDialog from '@/components/dashboard/questionbank/EditQuestionDialog'

export default {
    components: {
        CreateQuestion,
        ExpandedQuestion,
        EditQuestionDialog,
    },

    data() {
        return {
            questionbank: null,
            expandedItem: [],
            search: null,
            editDialog: false,
            headers: [
                {
                    text: 'Label',
                    value: 'label',
                }, {
                    text: 'Bidang',
                    value: 'field',
                }, {
                    text: 'Pertanyaan',
                    value: 'question_summary'
                }, {
                    text: 'Indeks Kesulitan',
                    value: 'difficulty_index'
                }, {
                    text: '',
                    value: 'action'
                }, {
                    text: '',
                    value: 'data-table-expand'
                }
            ]
        }
    },

    computed: {
        questions: get('questionbank/questions')
    },

    methods: {
        edit(item) {
            this.$store.set('questionbank/selectedQuestionId', item.id)
            this.editDialog = true
        }
    },

    created() {
        this.$api.get(`questionbank/${this.$route.params.questionbank_id}`, { loader: 'appbar' })
            .then(response => {
                this.questionbank = response.data
                this.$store.set('ui/title', this.questionbank.title)
            })

        this.$store.dispatch('questionbank/getQuestions', this.$route.params.questionbank_id);
    },

    destroyed() {
        this.$store.commit('questionbank/RESET')
    }
}
</script>
